import React from 'react';

import { SettingsManager, useSettings } from '@atlas/core';
import { ThemeChanger } from '@atlas/ui';

const darkTheme = 'dark';
const lightTheme = 'light';

const HeaderSettings = () => {
  let { theme } = useSettings();
  if (!theme) {
    theme = SYS_CONFIG.defaultTheme;
  }
  const isNightMode = theme === darkTheme;

  const onChangeTheme = () => {
    const newTheme = isNightMode ? lightTheme : darkTheme;
    SettingsManager.updateSettings({ theme: newTheme });
  };

  return (
    <div className="dropdown-list__footer">
      <div className="header-theme">
        <ThemeChanger isNightMode={isNightMode} onClick={onChangeTheme} />
      </div>
    </div>
  );
};

export default HeaderSettings;
